import api from './api';

export interface LaunchMetrics {
  // User Acquisition
  total_signups: number;
  signups_today: number;
  signups_this_week: number;
  signups_this_month: number;
  signup_growth_rate: number;
  
  // User Engagement
  daily_active_users: number;
  weekly_active_users: number;
  monthly_active_users: number;
  average_session_duration: number;
  user_retention_7_day: number;
  user_retention_30_day: number;
  
  // Content Creation
  total_content_generated: number;
  content_generated_today: number;
  content_generated_this_week: number;
  content_generated_this_month: number;
  avg_content_per_user: number;
  
  // AI Usage
  ai_generations_total: number;
  ai_generations_today: number;
  ai_generations_this_week: number;
  ai_generations_this_month: number;
  most_popular_ai_type: string;
  ai_success_rate: number;
  
  // Export/Download
  total_exports: number;
  exports_today: number;
  exports_this_week: number;
  exports_this_month: number;
  most_popular_export_format: string;
  
  // Revenue
  total_revenue: number;
  revenue_today: number;
  revenue_this_week: number;
  revenue_this_month: number;
  mrr: number;
  arr: number;
  
  // Conversion
  free_to_paid_conversion_rate: number;
  trial_to_paid_conversion_rate: number;
  churn_rate: number;
  customer_lifetime_value: number;
}

export interface LaunchGoals {
  signups_week_1: number;
  signups_month_1: number;
  revenue_month_1: number;
  content_generations_month_1: number;
  paid_conversions_month_1: number;
}

class LaunchMetricsService {
  async getMetrics(period: string = 'month'): Promise<LaunchMetrics> {
    const response = await api.get(`/admin/launch-metrics/metrics?period=${period}`);
    return response.data;
  }

  async getGoals(): Promise<LaunchGoals> {
    const response = await api.get('/admin/launch-metrics/goals');
    return response.data;
  }

  async getUserEngagement(period: string = 'month') {
    const response = await api.get(`/admin/launch-metrics/user-engagement?period=${period}`);
    return response.data;
  }

  async getContentMetrics(period: string = 'month') {
    const response = await api.get(`/admin/launch-metrics/content-metrics?period=${period}`);
    return response.data;
  }

  async getRevenueMetrics(period: string = 'month') {
    const response = await api.get(`/admin/launch-metrics/revenue-metrics?period=${period}`);
    return response.data;
  }

  async getConversionFunnel() {
    const response = await api.get('/admin/launch-metrics/conversion-funnel');
    return response.data;
  }
}

export default new LaunchMetricsService();